import type { SVGProps } from 'react';

export function FlameIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.48 2.147a1 1 0 0 1 1.49.611c.618 2.473 1.843 4.45 3.67 5.974C18.796 10.527 20 12.619 20 15a8.002 8.002 0 0 1-13.657 5.657A8 8 0 0 1 4 15a6 6 0 0 1 1.2-3.6A1 1 0 0 1 7 12a1.5 1.5 0 0 0 3 0c0-.735-.264-1.29-.645-2.052C8.986 9.209 8.5 8.264 8.5 7c0-1.781 1.113-3.372 2.875-4.781z" />
    </svg>
  );
}
